var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 23,
    viewBox: "0 0 30 23",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m32.1875 9h-24.375c-1.55332031 0-2.8125 1.2591797-2.8125 2.8125v16.875c0 1.5533203 1.25917969 2.8125 2.8125 2.8125h24.375c1.5533203 0 2.8125-1.2591797 2.8125-2.8125v-16.875c0-1.5533203-1.2591797-2.8125-2.8125-2.8125zm0 2.8125v2.390918c-1.3137891 1.0698633-3.4082813 2.733457-7.885957 6.2396484-.9867774.7761914-2.9414649 2.6409375-4.301543 2.6191992-1.3598437.0219727-3.3151758-1.8433008-4.301543-2.6191992-4.4769726-3.5056641-6.57199216-5.1696094-7.885957-6.2396484v-2.390918zm-24.375 16.875v-10.8751172c1.34261719 1.0693945 3.2466211 2.5700391 6.1487109 4.8425391 1.2806836 1.0081054 3.5234766 3.2335547 6.0387891 3.2200195 2.5029492.0135352 4.7173242-2.1796289 6.0382617-3.2195508 2.9020313-2.2724414 4.8065625-3.7734961 6.1492383-4.8430078v10.8751172z",
    fill: "#fff",
    transform: "translate(-5 -9)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.7c4a9fc6.svg";
export { ForwardRef as ReactComponent };